import { SelectItem } from 'primeng/api';

export enum ProviderSpecialty {
  Dentist = 1,
  GeneralPractice = 2,
  DentalPublicHealth = 3,
  Endodontics = 4,
  Orthodontics = 5,
  PediatricDentistry = 6,
  Periodontics = 7,
  Prosthodontics = 8,
  OralandMaxillofacialPathology = 9,
  OralandMaxillofacialRadiology = 10,
  OralandMaxillofacialSurgery = 11,
  Rehabitalization = 12,
  GeneralPhysiotherapy = 13,
  Anesthesiologist = 14,
  Cardiologist = 15,
  Coroners = 16,
  Dermatologist = 17,
  Diabetologist = 18,
  Emergencyphysician = 19,
  Endocrinologist = 20,
  Euthanasiadoctor = 21,
  Gastroenterologist = 22,
  Generalpractitioner = 23,
  Gynaecologist = 24,
  HighAltitudePhysician = 25,
  Hematologist = 26,
  Hygienist = 27,
  Immunologist = 28,
  Internist = 29,
  Leprologist = 30,
  Militaryphysician = 31,
  Nephrologist = 32,
  Neurologist = 33,
  Neurosurgeon = 34,
  Nuclearmedicinephysician = 35,
  Obstetrician = 36,
  Oncologist = 37,
  Ophthalmologist = 38,
  Orthopaedist = 39,
  Osteopathicphysician = 40,
  Otolaryngologist = 41,
  Parasitologist = 42,
  Pathologist = 43,
  Pediatrician = 44,
  Phthisiatrist = 45,
  Podiatrist = 46,
  Psychiatrist = 47,
  Pulmonologist = 48,
  Radiologist = 49,
  Rheumatologist = 50,
  Serologist = 51,
  Surgeon = 52,
  Teamphysician = 53,
  Toxicologist = 54,
  Traumatologist = 55,
  Tropicalphysician = 56,
  Urologist = 57,
  Venereologist = 58,
  Virologist = 59,
}

export enum SelectionCategory {
  ClinicalExaminations = 1,
  Symptoms = 2,
  Diagnosis = 3,
  RadiologyProcedures = 4,
  LabTests = 5,
  Treatments = 6,
  Medicines = 7,
  MedicalServices = 8
}
export enum NormalRangeType {
  All = -1,
  Normal = 1,
  Panic = 2,
  Confirmation = 3,
  MachineEdge = 4,
  QCLevel1 = 5,
  QCLevel2 = 6,
  QCLevel3 = 7,
  Unknown = 0,
  QCLevel1Mean = 9,
  QCLevel2Mean = 10,
  QCLevel3Mean = 11,
  MIC = 12,
  Zone = 13,
  Abnormal = 14

}
export class User {
  CompanyId: number;
  Username: string;
  Password: string;
  BranchId: number;
  language: number;
  companyCurrency: string;
  branchCurrency: string;
  IsProvider: boolean;
  picture: any;
  labId: number;
  payerFullName: string;
  payerId: number;
  payerPricelistId: number;
  providerId: number;
  processingLabId: number;
  referralLabId: number;
}


export class loginInfo {
  Username: string;
  Password: string;
  CompanyId: number;
  BranchId: number;
  language: number;
  languageId: number;
  ClientIP: string;
  CheckMaxSessionCount: boolean;

}

export class AuthInfo {
  username: string;
  timeout: number;
  token: string;
  sessionId: string;
  authMessage: string;
branchId: number;
companyId: number;
 
}

export class SessionInfo {
  sessionId: string;
  username: number;
  companyId: string;
  branchId: string;

}

export class DataMenus {

  isError: boolean;
  error: string;
  errorCode: string;
  aPIVersion: string;
  data: SystemMenus[];

}

export declare class MenuItem {
  id: number;
  menuType?: number;
  parentId: number;
  label: string;
  AlternativeName: string;
  url: string;
  icon: string;
  Application: Application;
  routerLink: string;
  formCode: string;
  moduleCode: string;
  systemCode: string;
  command?: (event?: any) => void;
  items: MenuItem[];
}

export declare class FavItems {

  id: number;
  url: string;
  name: string;
}

export class FavoriteMenuDTO {
  uRL: string;
  uSER_DEFAULT_PAGE_SMU_ID?: number;
  uSER_DEFAULT_PAGE_APP_ID?: number;
  iS_FAVORITE?: number;
  iD?: number;
  cAM_APP_ID?: number;
  mODIFICATION_DATE?: Date;
  nAME: string;
  uSERNAME: string;
  cAM_SMU_ID?: number;
  cUSTOM_NAME: string;
}

export declare enum Application {

  iCore3 = 32,
  CareNet = 203,

}

export class SystemMenus {
  applicationId: number;
  CAM_FRM_CL_ID: number;
  formCode: string;
  moduleCode: string;
  systemMenuId: number;
  systemCode: string;
  companyId: number;
  helpPageURL: string;
  id: number;
  menuOrder: number;
  menuType: number;
  name: string;
  name2: string;
  url: string;
  showInMenu: boolean;
  hostName: string;
  isAuthorizedMenu: boolean;
}


export enum Preferences {
  ApplyClassSecurityOnSetupModule = "SST001",
  StopDeleteAttachmentAfterDocumentPosting = "GST001",
  ExpiryDateLessThanIssueDateForPoliciesAndEndt = "GST006",
  PerviousDaysValidation = "GST007",
  ExcludeClassesfromDocumentIssueDateMinTodaysDatedifference = "GST008",
  MarineCargoExpiryDateOptional = "GST009",
  ProductNameIsRequiredOrNotRequired = "MPD001",
  IssueDateEqualSystemDateAndNotEditable = "MPD002",
  EffectiveDateEqualOrAfterIssueDate = "MPD003",
  FinancialDateEqualIssueDateAndNotEditable = "MPD004",
  ActivatePolicySponsorsBehavior = "MPD005",
  UsePromotionCode = "MPD006",
  MasterPolicyHolderIsRequired = "MPD007",
  RoundationOfDecimalPoints = "MPD008",
  MemberAgeCalculation = "MPD009",
  MemberIdentityTypeValidation = "MPD010",
  ActivateMemberPolicySponsorsBehavior = "MPD011",
  MemberUniquenessType = "MPD012",
  MemberNationalIDMandatoryOptional = "MPD013",
  MemberIdentityTypeNationalIDApplicationIDVisaNoLength = "MPD014",
  staffNumberUniqueness = "MPD015",
  CheckPrincipleRelationForSpouse = "MPD016",
  MemberStaffNoIsMandatoryOptional = "MPD017",
  MobileNoMaxLength = "MPD018",
  AllowRejectChangingThePolicyInClaims = "MCL001",
  ProviderSuggestFiltration = "MCL002",
  TerritoryScopeValidation = "MCL003",
}


export class CompaniesDTO {
  aCCOUNT_NO: string;
  aDDRESS: string;
  aDDRESS2: string;
  appID: number;
  cOM_ID: number;
  iD: number;
  cRG_COM_ID: number;
  cONTACT_PERSON: string;
  cRG_CNT_CODE: string;
  cRG_CUR_CODE: string;
}

export class Company {
  id: number;
  name: string;
}
export class Branch {
  id: number;
  name: string;
}
export class CompanyDataContent {
  content: Company[];
}

export class BranchDataContent {
  content: Branch[];
}
export class CoreResponse<T> {
  code: string;
  message: string;
  content: T;
  isError: boolean;
  isUserLogin: boolean;

  fromJSON(json) {
    for (var propName in json)
      this[propName] = json[propName];
    return this;
  }
}

export class CustomResponse {
  code: string;
  message: string;
}

export class Serializable {

  fromJSON(json) {
    for (var propName in json)
      this[propName] = json[propName];
    return this;
  }

}

export enum MessageType {
  Info = 1,
  Success = 2,
  Warn = 3,
  Error = 4
}

export declare class ResponseResult<T> {
  data: T;
  errors: string[];
  status: Status;
  totalRecords?: number;
}

export declare enum Status {
  Failed = 0,
  Success = 1,
  SuccessWithRedirect = 2,
  SuccessWithWarning = 3
}

export class CareNetAPIResponse<T> {
  IsError: boolean;
  APIMessage: string;
  data: T;
  totalRecordsCount: number;

  fromJSON(json) {
    for (var propName in json)
      this[propName] = json[propName];
    return this;
  }
}

export class CoreData {
  sessionId: string;
  token: string;
  refreshToken: string;
  username: string;
  companyId: number;
  branchId: number;
  language: number;
  sesstionTimeOut: string;
  loginSource: string;
}

export enum MedicalTestType {
  All = -1,
  ClinicExamination = 27,
  Lab = 8,
  Radiology = 26,
  Questionnaire = 38,
  Assessment = 39,
  SurgeryForm = 40,
  DietitianNotes = 41
}

export const ProviderTypeReferralSetup = [

  { Id: -1, Name: "All" },
  { Id: 0, Name: "Doctor" },
  { Id: 2, Name: "Hospital" },
  { Id: 3, Name: "Pharmacy" },
  { Id: 4, Name: "Lab" },
  { Id: 5, Name: "Radiology" },
  { Id: 6, Name: "Medical Center" },
  { Id: 7, Name: "Physiotherapy" },
  { Id: 9, Name: "Dental" },
  { Id: 10, Name: "Optical" },
  { Id: 11, Name: "LabC enter" },
  { Id: 12, Name: "Radiology Center" },
  { Id: 13, Name: "Physiotherapy Center" },
  { Id: 14, Name: "Emergency" }

];

export enum ProviderType {
  None = 0,
  All = -1,
  Doctor = 1,
  Hospital = 2,
  Pharmacy = 3,
  Lab = 4,
  Radiology = 5,
  MedicalCenter = 6,
  Physiotherapy = 7,
  Dental = 9,
  Optical = 10,
  LabCenter = 11,
  RadiologyCenter = 12,
  PhysiotherapyCenter = 13,
  Emergency = 14,
  LabMachine = 15,
  Section = 16,
  PharmacyCenter = 17,
  PolyClinic = 18,
  Operations = 19,
  CriticalCare = 20,
  InpatientWithSpecialty = 21,
  ClinicWithSpecialty = 22,
  Room = 23,
  RadiologyMachine = 24,
  Machine = 25,
  Nurse = 26,
  Dietitian = 27
}

export enum VisitDiseaseType {
  Primary = 1,
  Secondary = 2
}

export enum VisitDiseaseStatus {
  Provisional = 1,
  Final = 2
}


export enum AuthorizationStatus {
  None = -1,
  Pending = 1,
  Submitted = 2,
  Resubmitted = 3,
  Approved = 4,
  Rejected = 5,
  Canceled = 6,
  HasError = 7
}

export enum PrescriptionItemDurationUnit {
  Days = 1,
  Weeks = 2,
  Months = 3,
  Chronic = 4
}


export class CustomFileUpload {

  fileContents: any[];
  uploadedBy: string;
  visitId: number;
}

export enum RadiologyProcedureStatus {
  All = -1,
  Requested = 1,
  WaitingApproval = 2,
  ApprovedCash = 3,
  ApprovedInsured = 4,
  UnderProcessing = 5,
  Completed = 6,
  Cancled = 7,
  RequiredResultReport = 8,
  InProgress = 9,
  ResultReady = 10,
  ReportReady = 11,
  Dispatched = 12,
  Unsigned = 13,
  Signed = 14,
  BillGenerated = 15
}

export enum LabTestType {
  Group = 1,
  Multiline = 2,
  SingleLine = 3,
}

export const RadiologyProcedureStatusList = [

  { Id: -1, Name: "All" },
  { Id: 3, Name: "Approved Cash" },
  { Id: 4, Name: "Approved Insured" },
  { Id: 6, Name: "Completed" },
  { Id: 8, Name: "Required Result Report" }


];

export enum MedicalUploadType {
  Others = 0,
  IDCard = 1,
  Passport = 2,
  BirthCertificate = 3,
  ConsentForm = 4,
  InsuranceCard = 5,
  LabResult = 6,
  RadiologyReport = 7,
  Disclaimer = 8,
  MedicalServiceFile = 9,
  PatientImage = 10
}

export enum ControlTypes {
  FreeText = 1,
  Numeric = 2,
  Date = 3,
  YesOrNo = 4,
  DropDownList = 5,
  CheckBoxes = 6,
  RadioButtons = 7,
  Image = 8,
  Percentage = 9,
  Nil = 10,
  PlusMinus = 11,
  Formula = 12,
  Ratio = 13,
  UploadFile = 14
}

export enum Gender {
  Male = 1,
  Female = 2,
  Both = 3,
}


export enum AppointmentStatus {
  Requested = 6,
  Booked = 1, // to be Booked
  Confirmed = 7,
  NoAnswer = 8,
  Canceled = 2,
  NoShow = 5,
  Waiting = 9,
  BeingSeen = 10,
  WaitingCanceled = 12,
  Seen = 11,
  Completed = 4,
  DoctorFreeReserved = 13,
  ReceptionFreeReserved = 14,
}

export class CustomerSubscription {

  isValid: boolean;
  message: string;
  subscriptionId: string;
}

export enum ReferralReasonType {
  All = -1,
  Surgery = 1,
  Admission = 2,
  Emergency = 3,
  Consultation = 4,
  Radiology = 5,
  Laboratory = 6,
  DayCase = 7
}

export enum ActivityType {
  All = 0,
  MedicalService = 1,
  Medicine = 2,
  LabTest = 3,
  RadiologyProcedure = 4,
  ClinicalExmaination = 5,
  MedicalSupplies = 6,
  RadiologySupplies = 7,
  SurgerySupplies = 8,
  RoomService = 9,
  Package = 10,
  Assessment = 11,
  GiftVoucher = 14,
  AccomodationServices = 15,
  DiagnosisServices = 16,
  CareUnitServices = 17,
  SurgeryServices = 18,
  EmergencyServices = 19,
  VoucherPackage = 20,
  GroupService = 21,
  GroupAssemblyService = 22,
  DoctorFees = 23,
  LabSupplies = 24,
  Surgery = 25,

  CardiologyServices = 26,
  EndoscopyServices = 27,
  DeliveryServices = 28,
  CafeteriaServices = 29,
  PhysiotherapyServices = 30
}

export enum LabTestSampleStatus {
  Registered = 1,
  Collected = 2,
  ReceivedInLab = 3,
  InProgress = 4,
  Rejected = 5,
  Released = 6,
  Prefinalized = 7,
  OnHold = 8,
  Finalized = 9,
  DestinationChanged = 10,
  Referred = 11,
  Canceled = 12,
  Lost = 13,
  Rejected_Review_Completed = 14,
  dePrefinalized = 15,
  deFinalized = 16,
  Approved = 17,
  DisApproved = 18
}

export enum LaboratoryOrderStatus {
  New = 1,
  InProgress = 2,
  Completed = 3,
  Hidden = 4,
  Confirmed = 5 
}

export enum LabOrderUrgency {
  Urgent = 1,
  Normal = 2
}

export enum TreatmentOrderStatus {
  All = -1,
  Open = 1,
  Completed = 2,
  InProgress = 3,
  Booking = 4,
  Release = 5,
  Issuance = 6,
  Return = 7
}

export enum AdmissionSource {
  ClinicReferral = 1,
  PhysicianReferral = 2,
  ERReferral = 3,
  HospitalReferral = 4,
  HMOReferral = 5,
  /// <summary>
  /// Skilled Nursing Facility
  /// </summary>
  /// <remarks></remarks>
  SNFReferral = 6,
  AnotherHealthReferral = 7,
  CountLawEnforcement = 8,
  InformationNotAvailable = 9,
  /// <summary>
  /// Psych Substance Abuse Or Rehab Hospital Referral
  /// </summary>
  /// <remarks></remarks>
  PSARHR = 10,
  /// <summary>
  /// Critical Access Hospital Referral
  /// </summary>
  /// <remarks></remarks>
  CAHR = 11
}

export enum AdmissionType {
  Elective = 1,
  Emergency = 2,
  Urgent = 3,
  NewBorn = 4,
  PoliceCase = 5,
  Delivery = 6,
  Accident = 7,
  Operation = 8,
  Accommodation = 9,
  DayCase = 10,
  TraumaCenter = 11,
  InformationNotAvailable = 12
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum BenefitType {
  InPatient = 1,
  OutPatient = 2,
  Dental = 3,
  Maternity = 4,
  Optical = 5,
  Emergency = 6
}

export enum PatientStickerType {
  PatientInfo = 1,
  MedicineInfo = 2
}

export enum VisitArrivalMethod {
  Ambulance = 1,
  Self = 2
}

export enum UrgencyLevel {
  Resuscitation = 1,
  Emergency = 2,
  Urgent = 3,
  SemiUrgent = 4,
  NonUrgent = 5
}

export enum EncounterType {
  All = -1,
  Clinic = 1,
  Lab = 2,
  Radiology = 3,
  Admission = 4,
  Pharmacy = 5,
  Emergency = 6,
  PrimaryCare = 7,
  Physiotherapy = 8,
  ExternalPatient = 9,
  InternalPatient = 10,
  TransientPatient = 11,
  VascularPatient = 12,
  InternalTransientPatient = 13
}
export enum subscriptionParameterCode {
  userCount = 'UC',
  doctorCount = 'DC',
  patientMobileApp = 'PM',
  userTraining = 'UT',
  onlineVisit = 'OV',
  diskSpace = 'DS',

}

export enum ProviderLevel {
  All = -1,
  Branch = 1,
  Department = 2,
  Staff = 3,
  Machine = 4,
  Room = 5
}

export enum ItemSource {
  NewAdmission = 1,
  LabOrder = 2,
  RadiologyOrder = 3,
  DischargePrescription = 4,
  NewMedicineOrder = 5,
  NewClaim = 6,
  VisitTreatment = 7
}

export enum InsuranceCompanyType {
  All = -1,
  TPA = 1,
  Insurance = 2, //Insurance
  Payer = 3,
  Loyalty = 4
}

export enum AgreementLevel {
  TPA = 1,
  InsuranceCompany = 2,
  Plan = 3,
  Servicetype = 4,
  ServiceCategory = 5,
  Service = 6
}

export enum AppointmentAttendanceType {
  Inperson = 1,
  Online = 2
}

export enum IntegrationType {
  DirectIntegration = 1,
  TPO = 2,
  LegacyDirectIntegration = 3
}

export enum AdmissionStatus {
  Requested = 1,
  Confirmed = 2,
  Waiting = 3,
  Canceled = 4,
  ReadyToBeDischarged = 5,
  Discharged = 6,
  CheckedIn = 7,
  NeedsDischarge = 8
}

export enum EReferralRequestStatus {
  All = -1,
  New = 1,
  Approved = 2,
  PartiallyApproved = 3,
  Rejected = 4,
  Sent = 5
}

export enum PaymentRequestStatus {
  All = -1,
  Requested = 1,
  Completed = 2
}

export enum BillStatus {
  Unspcified = 0,
  New = 1,
  Confirmed = 2,
  PartiallyPaid = 3,
  Paid = 4,
  PostedToFinancial = 5,
  Unposted = 6,
  Canceled = 7,
  UnConfirmed = 8,
  ZeroAmount = 9
}

export enum PatientShareType {
  Percentage = 1,
  Deductible = 2
}

export enum VisitStatus {
  All = -1,
  History = 1,
  Active = 2,
  Pending = 3,
  Planned = 4,
  WaitingApproval = 5,
  Referred = 6,
}

export enum AppointmentVisitType {
  New = 1,
  Followup = 2,
  TreatmentPlan = 3
}

export enum TreatmentType {
  Treatment = 1,
  Removal = 2,
}

export enum ToothServiceStatus {
  All = -1,
  Planned = 1,
  Inprogress = 2,
  Completed = 3,
  UnPlanned = 4
}

export enum VitalSignMode {
  Static = 1,
  Dynamic = 2
}

export enum ExaminationRangeType {
  High = 1,
  Normal = 2,
  Low = 3,
}

export enum Lookups {
  //Personal enums
  Gender = 1,

  //Data Management enums
  CodingSystem = 2,
  FrequencyUnits = 4,
  //LabTestCategory = 8,
  SymptomGroup = 9,
  AllergyType = 10,
  DosageForm = 11,
  SurgerySpecialty = 12,
  UserType = 13,
  Profession = 14,
  MedicalTestType = 23,
  ServiceType = 24,
  DiseaseGroup = 28,
  BodySystems = 29,
  Questionnaire = 38,

  //Medical History
  UploadStatus = 15,
  FamilyRelation = 19,
  PatientIdentityType = 47,
  MaritalStatus = 50,

  //Service Provider enums
  ServiceProvider = 5,
  Qualifications = 6,
  ActivityType = 51,

  //Rewards
  ProductCategory = 7,

  //Clinics Management
  CaseShared = 16,
  DiagnosticTestStatus = 17,
  VisitStatus = 18,
  BloodGroup = 20,
  BenefitType = 21,
  Tooth = 31,
  AdmissionStatus = 52,

  //Communication
  CommunicationEventType = 30,

  //Radiology
  RadiologyPreparations = 32,
  RadiologyProcedureStatus = 41,

  //Lab
  LabPreparations = 33,
  SampleContainer = 35,
  SampleRejectionReason = 36,
  SampleStatus = 37,

  //RoomType
  RoomType = 39,

  //Dental Departments
  DentalDepartment = 40,

  EncounterStatus = 41,
  EncounterType = 42,
  EncounterSource = 43,
  AdmissinType = 44,
  EncounterItemStatus = 45,
  LabTestStatus = 46,

  //ADT
  AdmissionSource = 48,
  AdmissionType = 49,
  Inquiry = 53,

  //Machine Type
  CommStandardType = 54,
  FunctionalType = 55,
  ConnectionType = 59,

  //Machine Setup
  MachineStatus = 56,
  //Medical Test
  TurnAroundTimeUnit = 57,
  MedicalTestStatus = 58,

  NormalRangeType = 60,
  BarcodeType = 61,

  AttributeCodeCategory = 62,

  MemberRace = 63,

  MachineMethodFactor = 64,

  BillPaymentMethod = 65,

  VoucherType = 66,

  SurgeryType = 67,

  VoucherStatus = 68,

  ChiefComplaints = 69,

  VisitArrivalMethod = 70,

  OpeationOrderStatus = 71,

  OperationOrderPriority = 72,
  VascularStatus = 73,
  VascularAccessLocation = 74,

  ReportCategory = 75,

  ReferralReason = 76,

  ReferralType = 77,

  SymptomLevelofPain = 78,

  CalculationMethod = 79,

  FinancialTransactionType = 80,
  ContractType = 81,
  ExpectedRejectionReason = 82,
  QuestionStatus = 83,
  QualityComments = 84,
  BatchUploadType = 85,
  ProviderContractRateType = 86,
  DeFinalizedReason = 87,
  ProviderTypeAbbreviation = 88,
  SystemActionControlType = 89,
  TreatmentOrderType = 90,
  ClaimLogType = 91,
  MedicalAuditingReport = 92,
  ExaminationRangeType = 95,
  SystemAlertParameters = 96
}

export enum SpecialtyType {
  Medical = 1,
  Dental = 2,
  Physiotherapy = 3,
}

export enum LaboratoryTestStatus {
  All = -1,
  Requested = 1,
  New = 2,
  WaitingApproval = 3,
  ApprovedCash = 4,
  ApprovedInsured = 5,
  UnderProcessing = 6,
  Completed = 7,
  Canceled = 8,
  Authenticated = 9,
  Printed = 10,
  Dispatched = 11,
  Unsigned = 12,
  Signed = 13,
  RequiredResultReport = 14
}

export enum RoomStatus {
  Active = 1,
  Inactive = 2
}

export enum RoomType {
  Accommodation = 1,
  CareUnit = 2,
  Operations = 3,
  Emergency = 4,
  RecoveryRoom = 5
}

export enum InsuranceFormType {
  PaperFormsOnly = 1,
  EFormsAndPaperForms = 2,
  EForms = 3
}

export enum ItemTypeStatus {
  Active = 1,
  Inactive = 2
}

export enum QuestionStatus {
  Active = 1,
  Inactive = 2
}

export enum Status {
  Active = 1,
  Inactive = 2
}

export enum InterActiveTestChartType {
  SpeedMeter = 1,
  LinearChart = 2
}

export enum ProviderStatus {
  None = -1,
  Active = 1,
  Inactive = 2,
  Unsubscribed = 3,
}

export enum GestationAgeUnit {
  Weeks = 1,
  Months = 2
}

export enum ClosingReason {
  Delivery = 1,
  Miscarriage = 2,
  NotCompletelyTheVisit = 3
}

export enum DeliveryMode {
  CesareanSection = 1,
  NormalDelivery = 2
}

export enum MiscarriageType
{
  Spontaneous = 1,
    Elective = 2,
    Incomplete = 3
}
